import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import Careers from 'features/careers/Careers'
import type { CareersPageProps } from 'features/careers/types'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { useTranslation } from 'next-i18next/pages'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'

const CareersPage = (props: CareersPageProps) => {
  // i18n
  const { t } = useTranslation('careers')

  // Constants
  const seo: SeoProps = {
    title: t('seo.title'),
    description: t('seo.description')
  }

  return (
    <Layout {...{ seo }}>
      <Careers {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const jobOffers = await cmsLib.getJobOffers(locale)

  return {
    props: {
      jobOffers,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'careers', 'about'], i18nConfig))
    },
    revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
  }
}

export default CareersPage
